import { __exportAll } from "../../_virtual/_rolldown/runtime.js";
import { CaptionsRadioGroupOptions, CaptionsRadioGroupRoot, CaptionsRadioGroupValue } from "./component.js";
//#region src/ui/captions-radio-group/index.parts.ts
var index_parts_exports = /* @__PURE__ */ __exportAll({
	Options: () => CaptionsRadioGroupOptions,
	Root: () => CaptionsRadioGroupRoot,
	Value: () => CaptionsRadioGroupValue
});
//#endregion
export { CaptionsRadioGroupOptions as Options, CaptionsRadioGroupRoot as Root, CaptionsRadioGroupValue as Value, index_parts_exports };

//# sourceMappingURL=index.parts.js.map